import { render, staticRenderFns } from "./SalesTable.vue?vue&type=template&id=16e890a6&"
import script from "./SalesTable.vue?vue&type=script&lang=js&"
export * from "./SalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e890a6')) {
      api.createRecord('16e890a6', component.options)
    } else {
      api.reload('16e890a6', component.options)
    }
    module.hot.accept("./SalesTable.vue?vue&type=template&id=16e890a6&", function () {
      api.rerender('16e890a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/SalesTable.vue"
export default component.exports